module.exports = __webpack_public_path__ + "media/images/icons/icon_facebook_login-509c0e445d545c02200046e9b2081464.svg";